<app-settings-base
  title="{{'centralInsolvencyRegisterSettings.title' | translate}}"
  description="{{'centralInsolvencyRegisterSettings.text' | translate}}"
  details="{{'centralInsolvencyRegisterSettings.detailsHeader' | translate}}"
  sourceUrl="/setting/central-insolvency-register">
</app-settings-base>
